<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="zone"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="zonaForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Zona Listing"
          addButton="Tambah Zona"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Zona Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Zona</h3>
          </div>

          <b-form id="zonaForm" validated novalidate>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="code_area" label="Zona">
                  <b-form-input
                    id="code_area"
                    type="text"
                    v-model="$v.zonaForm.code_area.$model"
                    :state="!$v.zonaForm.code_area.$invalid"
                    required
                    placeholder="Zona"
                  ></b-form-input>
                  <b-form-invalid-feedback>Zona harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label-for="description" label="Deskripsi">
                  <b-form-textarea
                    id="description"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.zonaForm.description.$model"
                    :state="!$v.zonaForm.description.$invalid"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="saveProcess"
              :disabled="$v.zonaForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";

export default {
  name: "zone",
  components: { globalTable, ModelSelect },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zone: [],
      loading: true,
      fields: [
        { key: "code_area", label: "Zona", sortable: true },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "text-center width-80" }
      ],
      zonaForm: masterInterfaces.zone,
      isEdit: false
    };
  },
  validations: {
    zonaForm: {
      code_area: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getZone();
    },
    getZone: function() {
      this.axios
        .get("web/master/zone/all/")
        .then(response => {
          this.zone = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.zonaForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.zone) {
        masterInterfaces.zone[a] = null;
      }
      this.zonaForm = masterInterfaces.zone;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah zona ini?")) {
          this.axios
            .put("web/master/zone/edit/", this.zonaForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Zona Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
                this.expired(error, 'Ubah Zona');
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan zona ini?")) {
          this.axios
            .post("web/master/zone/add/", this.zonaForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Zona Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Zona Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Tambah Zona');
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  